// removed by extract-text-webpack-plugin
module.exports = {"summary":"o-pzro7CpY_E-vmzibScg","summaryLabel":"_3zAeOwiqVQ6__-g-mc30LC"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/OasisTokenBalanceSummary.scss
// module id = 1227
// module chunks = 0